const refund = {
  path: 'refund',
  component: resolve => require(['../../../../components/pages/user/refund'], resolve),
  children: [{
    path: 'supply/:refundId',
    props: true,
    component: resolve => require(['../../../../components/pages/user/refund/supply'], resolve)
  }, {
    path: 'notice',
    component: resolve => require(['../../../../components/pages/user/refund/notice'], resolve)
  }]
}

export default refund



// WEBPACK FOOTER //
// ./src/router/pages/user/refund/index.js